import axios from 'axios';

const login = async (email, password) => axios.post('/User/Login', { email, password });

const signup = async (name, email, phone, password, role) => axios.post('/User/Signup', { name, email, phone, password, role });

const verifyOtp = async (phone, otp_code) => axios.post('/User/VerifyOtp', { phone, otp_code });

const resendOtp = async (phone) => axios.get('/Login/SendOtp', { params: { MobileNo: phone } });

// Send OTP using legacy Login controller endpoint (returns Result and optionally ResultSet with demo otp)
const sendOtp = async (mobileNo) => axios.get('/Login/SendOtp', { params: { MobileNo: mobileNo } });

// TestGetUserRole - returns the role for a given mobile number
// Add simple in-memory caching and request deduplication to avoid repeated
// backend calls when multiple components request the same mobile in quick succession.
const _roleCache = {}; // { [mobile]: { expires: timestamp, value: response } }
const _rolePromises = {}; // ongoing requests to dedupe concurrent calls
const testGetUserRole = async (mobileNo) => {
	const key = String(mobileNo || '').replace(/\D/g, '');
	const now = Date.now();
	// short TTL: 60 seconds
	const TTL = 60 * 1000;

	if (!key) return Promise.resolve(null);

	// return cached response if still valid
	const cached = _roleCache[key];
	if (cached && cached.expires > now) {
		return Promise.resolve(cached.value);
	}

	// if a request is already in-flight for this key, return its promise
	if (_rolePromises[key]) return _rolePromises[key];

	// otherwise start a request and cache the promise
	const p = axios.get('/Login/TestGetUserRole', { params: { mobileNo: key } })
		.then((res) => {
			try {
				_roleCache[key] = { expires: Date.now() + TTL, value: res };
			} catch (e) {
				// ignore cache set failures
			}
			delete _rolePromises[key];
			return res;
		})
		.catch((err) => {
			delete _rolePromises[key];
			throw err;
		});

	_rolePromises[key] = p;
	return p;
};

// Add new user (Admin creation uses Login/AddUser endpoint as provided)
const addUser = async (userPayload) => axios.post('/Login/AddUser', userPayload);

// Some legacy MVC controllers expect form-encoded data. Provide a form-encoded variant.
const addUserForm = async (userPayload) => {
	const params = new URLSearchParams();
	Object.keys(userPayload || {}).forEach(k => {
		const v = userPayload[k];
		if (v !== undefined && v !== null) params.append(k, String(v));
	});
	return axios.request({
		method: 'post',
		url: '/Login/AddUser',
		data: params.toString(),
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	});
};

const UserService = { login, signup, verifyOtp, resendOtp, sendOtp, testGetUserRole, addUser, addUserForm };

export default UserService;